import styled, { css } from 'styled-components'
import NativeLink from '../link'
import Button from '../button/button'
import { transition, hideAtMobile, showAtMobile, Media } from '../../theme'

export const StyledWrapper = styled.div`
  width: 1400px;
  display: flex;
  align-items: center;
  border: none;
  min-width: 1200px;
  display: flex;
  justify-content: space-between;
  .hide-at-mobile {
    ${hideAtMobile}
  }
  ${Media.phone`
    justify-content: space-between;
    min-width: unset;
    padding-left: .3rem;
  `}
`
const commonLink = css`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin: 0 30px;
  padding-top: 4px;
  font-weight: normal;
  height: 68px;

  line-height: 16px;
  color: ${p => (p.isActive ? p.theme.color.secondary : '#000')};
  font-size: 16px;
  span {
    font-weight: normal;
  }
  border-bottom: 2px solid transparent;
  transition: ${transition('border-color', 'color')};

  &:hover {
    /* color: ${p => p.theme.color.secondary}; */
    border-bottom-color: ${p => p.theme.color.secondary};
  }
`
export const Link = styled(NativeLink)`
  width: auto !important;
  /* border-bottom: 4px solid ${p => (p.isActive ? p.theme.color.secondary : 'transparent')}; */
`
export const Navbar = styled.header`
  display: flex;
  align-content: center;
  justify-content: center;
  position: fixed;
  z-index: 4800;
  top: ${({ showTopNotice }) => (showTopNotice ? '80px' : '0px')};
  width: 100%;
  height: 68px;
  min-width: 100px;
  background: ${p => (p.isTransparent ? 'rgba(255,255,255, 1)' : 'rgba(255,255,255, 1)')} !important;
  border-bottom: 1px solid #e5e5e5;
  ${Media.phone`
    height: 1.2rem;
    top: ${({ showTopNotice }) => (showTopNotice ? '.96rem' : '0px')};
  `}
`

export const Brand = styled.a`
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
  height: 60px;
  display: flex;
  align-items: center;
  svg {
    ${({ theme: { Hack } }) => css`
    width: 95px;
    height: 30px;

  ${Hack.desktopForeign`
    width: 150px;
  `}

  ${Media.phone`
    width: 1.2rem;
    height:.4rem;
  `}

  ${Hack.mobileForeign`
    width: 1.8rem;
  `}
`}
  }
`

export const LinkWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  > a {
    ${commonLink};
  }
`
export const NavbarWrap = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 68px;
  ${Media.phone`
    padding: .1rem .7rem .1rem 0;
    justify-content: flex-end;
  `}
`

export const ApplyButton = styled(Button)`
  min-width: 134px;
  height: 40px;
  border-radius: 4px;
  ${Media.phone`
    min-width: 2rem;
    height: 0.72rem;
    font-size: 0.24rem;
    margin: auto;
    line-height: normal;
    border-radius: 3px;
  `}
`

export const DropdownWrapdiv = styled.div`
  width: 1400px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DropdownWrap = styled.div`
  ${({ theme: { color, typography, Hack }, isOpen, isResources }) => css`
    display: ${isOpen ? 'block' : 'none'};
    justify-items: center;
    position: fixed;
    left: 0;
    right: 0;
    white-space: nowrap;
    top: ${({ showTopNotice }) => (showTopNotice ? '148px' : '68px')};
    width: 100%;
    text-align: left;
    height: ${isResources ? '600px' : '162px'};
    background: #ffffff;
    border: 1px solid #f3f6f7;

    a,
    span {
      width: 12em;
      line-height: 32px;
      display: block;
      color: #636772;
      font-size: ${typography.textThin};
      ${Hack.en`
        width: 20em;
        font-size: ${typography.textMini};
      `}
      ${Hack.ja`
        width: 16em;
      `}
    }
  `}
`

export const DropdownMenu = styled.div`
  ${commonLink};
  cursor: default;
  /* &:hover > ${DropdownWrap} {
    display: ${p => (p.hasMulti ? 'flex' : 'block')};
    padding: ${p => (p.hasMulti ? '' : '10px')};
  } */
   padding: 0 8px;
`

export const IconWrap = styled.div`
  ${({ theme: { color, Hack } }) => css`
    ${showAtMobile}
    ${Media.phone`
      display: flex;
      padding-right: .3rem;
      svg {
        width: 0.5rem;
        height: 0.5rem;
        color: #C1C7D6;
        path {
          color: #C1C7D6;
        }
      }
    `}
  `}
`

export const MobileMenuContainer = styled.div`
  position: fixed;
  overscroll-behavior: contain;
  -ms-scroll-chaining: contain;
  left: 0;
  right: 0;
  top: 60px;
  z-index: 6000;
  ${Media.phone`
    top: ${({ showTopNotice }) => (showTopNotice ? '2.08rem' : '1.2rem')};
  `}
`
export const Mask = styled.div`
  width: 100vw;
  background-color: transparent;
  bottom: 0;
  height: ${p => (p.isExpand ? '20vh' : '0px')};
`
export const ListWrap = styled.div`
  position: relative;
  max-width: 100vw;
  overflow: auto;
  height: ${p => (p.isExpand ? '80vh' : '0px')};
  z-index: 9000;
  background: white;
  transition: ${transition('height')};
  border-radius: 0px 0px 20px 20px;
  ${p =>
    p.isExpand &&
    css`
      padding: 0 0 3rem 0;
    `}
`
export const ListItemLink = styled(Link)`
  display: block;
  padding: 0 0.4rem;
  line-height: 63px;
  position: relative;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: 500;
`
export const ListItemBlock = styled.div`
  display: block;
  padding: 0 0.4rem;
  line-height: 63px;
  position: relative;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  border: none;
  svg {
    &:last-of-type {
      margin-left: 0.1rem;
    }
    &:nth-of-type(3) {
      svg:first-of-type {
        margin-left: 0;
      }
    }
  }
`

export const ListItem = styled.div`
  list-style: none;
  max-height: ${p => (p.isExpand ? p.maxHeight + 'px' : '64px')};

  transition: max-height 0.5s ease-in;
  overflow: hidden;
`

export const TitleText = styled.p`
  && {
    display: inline-block;
    font-size: 14px;
    font-weight: bolder;
    color: #333333;
    margin-left: 0;
    margin-top: 0;
    &:hover {
      color: #fd5c1f;
    }
  }
`

export const ProductsLink = styled(NativeLink)`
  width: auto !important;
  height: 100%;
  display: flex;
  flex-direction: column; // 设置为垂直方向
  justify-content: space-between; // 确保子元素在垂直方向上靠边
  align-items: stretch; // 确保子元素的宽度填满父容器
  text-align: top;
  line-height: 20px;
  p {
    width: 100%;
    white-space: normal;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0em;
    font-variation-settings: 'opsz' auto;
    margin-top: 6px;
    color: #777777;
  }
  h2 {
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    color: #333333;
    width: auto;
    margin-right: 8px;
  }
  &:hover {
    h2 {
      color: #fd5c1f;
    }
    svg {
      path {
        fill: #fd5c1f;
      }
    }
  }
  ${Media.phone`
  p{
    margin-top:0;
  }
   `}
`
export const ProductsLS = styled.div`
  position: relative;
  width: 432px;
  height: auto;
  padding: 12px;
  border-radius: 6px;
  background: ${({ isActive }) => (isActive ? '#f3f6f7' : '#fff')};
  &:hover {
    background: #f3f6f7;
  }
  &:hover ${TitleText} {
    color: #fd5c1f;
  }
  &:hover ${ProductsLink} {
    svg {
      path {
        fill: #fd5c1f;
      }
    }
  }
  ${Media.phone`
    width: 100%;
    min-height: 2rem;
    height: auto;
    max-height: 4rem;
    &:hover {
      background: ${({ isActive }) => (isActive ? '#f3f6f7' : '#fff')};
    }
  `}
`

export const ProductsWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`

export const ProductsText = styled.div`
  display: inline-block;
  align-items: top;
  vertical-align: top;
`
export const ProductsLeft = styled.div`
  width: 56px;
`
export const ProductsRight = styled.div`
  width: 100%;
  color: #333333;
`
export const ResourcesLeft = styled.div`
  width: 420px;
  height: 100%;
  margin-right: 132px;
  ${Media.phone`
    width: 6.22rem;
  height: auto;
  min-height: 8rem;
  max-height: 20rem;
  margin: auto;
  padding: 0.4rem  0.28rem;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-bottom: 0.6rem;
  `}
`
export const ResourcesCenter = styled.div`
  width: 420px;
  height: 100%;
  margin-right: 144px;
  ${Media.phone`
    width: 6.22rem;
  height: auto;
  min-height: 4rem;
  max-height: 20rem;
  margin: auto;
  padding: 0.4rem  0.28rem;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-bottom: 0.6rem;
  `}
`
export const ResourcesRight = styled.div`
  width: 200px;
  height: 100%;
  ${Media.phone`
    width: 6.22rem;
  height: auto;
  min-height: 6rem;
  max-height: 20rem;
  margin: auto;
  padding: 0.4rem  0.28rem;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  `}
`
export const DropdownWrapRe = styled.div`
  width: 1400px;
  height: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding-top: 40px;
  p {
    font-family: Roboto;
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    color: #777777;
    margin-left: 12px;
    margin-bottom: 18px;
  }
  ${Media.phone`
  padding-top: 10px;
  width:100%;
  min-height: 8rem;
  max-height: 30rem;
  display:block;
  `}
`

export const ResourcesLS = styled.div`
  position: relative;
  width: 420px;
  height: auto;
  padding: 5px 12px 12px 12px;
  border-radius: 6px;
  color: #000;
  margin-bottom: 12px;
  background: ${({ isActive }) => (isActive ? '#f3f6f7' : '#fff')};
  &:hover {
    background: #f3f6f7;
  }
  &:hover ${TitleText} {
    color: #fd5c1f;
  }
  ${Media.phone`
  width:100%;
  max-height: 26rem;
  display:block;
  margin:0.4rem 0;
  &:hover {
    background:  #fff;
  }
  `}
`

export const ResourcesLink = styled(NativeLink)`
  width: auto !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  text-align: top;
  p {
    width: 100%;
    white-space: normal;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0em;
    color: #777777;
    font-variation-settings: 'opsz' auto;
    margin: auto;
    margin-top: 6px;
  }
  h2 {
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    color: #333333;
    margin-right: 8px;
  }
  &:hover {
    h2 {
      color: #fd5c1f;
    }
    svg {
      path {
        fill: #fd5c1f;
      }
    }
  }
`

export const RightLS = styled.div`
  position: relative;
  display: flex;
  width: 220px;
  height: auto;
  border-radius: 6px;
  color: #000;
  margin-bottom: 32px;
  background: ${({ isActive }) => (isActive ? '#f3f6f7' : '#fff')};
  &:hover {
    background: #f3f6f7;
  }
  &:hover ${TitleText} {
    color: #fd5c1f;
  }
  ${Media.phone`
    &:hover {
    background: #fff;
  }
  `}
`
export const Expanddiv = styled.div`
  width: 6.22rem;
  height: auto;
  min-height: 1rem;
  max-height: 20rem;
  margin: auto;
  padding: 0.4rem 0.28rem;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-top: 0.1rem;
`
export const ProductsIcon = styled.div`
  width: 40px;
  margin-top: 8px;
`
export const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: '#000000',
  opacity: 0.5,
  zIndex: 5,
}

export const Endiv = styled.div`
  width: 120px;
  display: flex;
  justify-content: center;
  align-content: center;
  svg {
    margin-top: 5px;
    margin: auto 8px;
  }
`
export const EnWarp = styled.div`
  position: absolute;
  top: 68px;
  background: #f8f9fb;
  border-radius: 4px;
  width: 140px;
  div {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: right;
    &:hover {
      background: #e8ebf0;
    }
    a {
      width: 70%;
    }
  }
`
export const LanguageLeft = styled.div`
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const LanguageRight = styled.div`
  width: 100%;
`
